import { render, staticRenderFns } from "./MarketingMerchantsData.vue?vue&type=template&id=72055fca&scoped=true&"
import script from "./MarketingMerchantsData.vue?vue&type=script&lang=js&"
export * from "./MarketingMerchantsData.vue?vue&type=script&lang=js&"
import style0 from "./MarketingMerchantsData.vue?vue&type=style&index=0&id=72055fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72055fca",
  null
  
)

export default component.exports